export const playDate1 = (state = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 3), action) => {
    switch (action.type) {
        case "SELECT_PLAY_DATE1": {
            return action.payload.playDate1
        }
        default: {
            return state;
        }
    }
};